// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__VoL_y","img":"styles_img__05XyU","pulse":"styles_pulse__suhr0","jump":"styles_jump__BGIyf","wiggle":"styles_wiggle___88QB"};